export default __webpack_public_path__ + "static/media/Thirst.67f68456.jpg";